import React from 'react'
import moment from 'moment'
import {IconButton, Tooltip} from '@mui/material'
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline'
import ModalCustom from '@ui/modal/ModalCustom'
import {IDeviceRecordingFile} from '@containers/monitoringPlatform/geoZones/types'
import {RecordingPlayer} from '@containers/monitoringPlatform/geoZones/recordingsByPeriod/RecordingPlayer'

interface IProps {
	accountId: number
	recording: IDeviceRecordingFile
}

export const PlayRecordingButton = ({accountId, recording}: IProps) => {
	return (
		<ModalCustom
			label={`${recording.licencePlate || recording.deviceId} · ${recording.cameraId} · ${moment(recording.recordedAt).format('DD.MM.YYYY HH:mm:ss')}`}
			button={
				<Tooltip title="Переглянути відео">
					<IconButton size="small" color="primary">
						<PlayCircleOutlineIcon fontSize="small"/>
					</IconButton>
				</Tooltip>
			}
			component={
				<RecordingPlayer
					accountId={accountId}
					recordingId={recording.id}
				/>
			}
		/>
	)
}

export default PlayRecordingButton
